import { Flex, Spin } from 'antd';

/**
 * The whole-screen wait, used for exactly one thing: the boot-time session
 * restore, before the app knows whether anyone is signed in
 * (docs/07-implementation-roadmap.md F1.1).
 *
 * A spinner rather than a skeleton, unlike `RouteFallback`: there is no way to
 * know yet whether the next screen is the login form or the shell, so there is
 * no shape to hold open.
 */
export function FullPageLoading() {
  return (
    <Flex align="center" justify="center" style={{ minHeight: '100vh' }}>
      <Spin size="large" aria-label="Memuat aplikasi" />
    </Flex>
  );
}
